import anonymousRepositoryHelper from './anonymousRepositoryHelper';

function ResponseRepository() {
  var self = this;

  var baseResponseUrl = '/api/response/';

  self.createResponseWithCaptchaValidation = function (parentDetails, captchaValue) {

    var responseDataModel = {
      captchaValue: captchaValue,
      parentDetails: parentDetails
    };

    return anonymousRepositoryHelper.ajaxPost(baseResponseUrl, responseDataModel);
  };

  self.getResponse = function (responsePublicReference) {
    var getResponseUrl = baseResponseUrl + responsePublicReference;

    return anonymousRepositoryHelper.ajaxGet(getResponseUrl, responsePublicReference);
  };

  self.completeResponse = function (responsePublicReference, responseDetails) {

    var responseDataModel = {
      responsePublicReference: responsePublicReference,
      responseDetails: responseDetails
    };

    var completeResponseUrl = baseResponseUrl + responsePublicReference;

    return anonymousRepositoryHelper.ajaxPut(completeResponseUrl, responseDataModel);
  };
}

export default new ResponseRepository();
